import StructuredData from "@/components/seo/StructuredData";
import { organisationSchema } from "@/utilities/seo";

/**
 * Injects a single LocalBusiness / Organization JSON-LD block. Mounted once
 * by the Layout so it appears on every page.
 */
export default function OrganisationStructuredData() {
    return <StructuredData data={organisationSchema()} />;
}
